// src/i18n/translations.js
// 中英文翻译文本

const translations = {
    // Header
    header: {
        cart: { en: 'CART', zh: '购物车' },
        cartCount: { en: '', zh: '' },
        shop: { en: 'SHOP', zh: '商店' },
        draft: { en: 'DRAFT', zh: '手稿' },
        press: { en: 'PRESS', zh: '媒体报道' },
        story: { en: 'STORY', zh: '故事' },
        qa: { en: 'Q&A', zh: '问答' },
        connect: { en: 'CONNECT', zh: '联系' },
        stockists: { en: 'STOCKISTS', zh: '合作伙伴' },
    },

    // Footer
    footer: {
        info: { en: 'INFO', zh: '信息' },
        social: { en: 'SOCIAL', zh: '社交' },
        socialOrg: { en: 'Social Organization', zh: '社会组织' },
    },

    // Shop 页面
    shop: {
        from: { en: 'From $', zh: '起价 $' },
    },

    // Product Detail
    product: {
        addToCart: { en: 'Add to Cart', zh: '加入购物车' },
        addedToCart: { en: '✓ Added to cart', zh: '✓ 已加入购物车' },
        quantity: { en: 'Quantity', zh: '数量' },
        freeShipping: { en: 'Free shipping on orders over $200', zh: '满 $200 免运费' },
        relatedProducts: { en: 'Related products', zh: '相关产品' },
        soldOut: { en: 'Sold Out', zh: '已售罄' },
    },

    // Cart
    cart: {
        title: { en: 'Shopping Cart', zh: '购物车' },
        empty: { en: 'Your cart is empty', zh: '您的购物车是空的' },
        emptyText: { en: 'Browse our collection and add items to your cart.', zh: '浏览我们的系列，将心仪的商品加入购物车。' },
        continueShopping: { en: '← Continue Shopping', zh: '← 继续购物' },
        subtotal: { en: 'Subtotal', zh: '小计' },
        shipping: { en: 'Shipping', zh: '运费' },
        free: { en: 'Free', zh: '免邮' },
        shippingCalc: { en: 'Calculated at checkout', zh: '结账时计算' },
        total: { en: 'Total', zh: '合计' },
        checkout: { en: 'Proceed to Checkout', zh: '去结账' },
        checkoutNote: { en: 'Shipping and taxes calculated at checkout', zh: '运费和税费将在结账时计算' },
        clearCart: { en: 'Clear Cart', zh: '清空购物车' },
        orderSummary: { en: 'Order Summary', zh: '订单摘要' },
        processing: { en: 'Processing...', zh: '处理中...' },
        checkoutError: { en: 'Checkout failed. Please try again.', zh: '结账失败，请重试。' },
        shippingRegionTitle: { en: 'Shipping Destination', zh: '配送目的地' },
        shippingDomestic: { en: 'United States ($20.00)', zh: '美国国内 ($20.00)' },
        shippingIntl: { en: 'International ($40.00)', zh: '国际 ($40.00)' },
    },

    // Checkout Success
    checkoutSuccess: {
        title: { en: 'Thank You for Your Order!', zh: '感谢您的订单！' },
        subtitle: { en: 'Your order has been placed successfully. We will send you a confirmation email shortly.', zh: '您的订单已成功提交。我们将很快给您发送确认邮件。' },
        orderDetails: { en: 'You will receive an email with your order details and tracking information once your item ships.', zh: '商品发货后，您将收到包含订单详情和物流信息的邮件。' },
        backToShop: { en: '← Back to Shop', zh: '← 返回商店' },
    },

    // Cart Notification
    cartNotification: {
        added: { en: 'Added to cart', zh: '已加入购物车' },
        qty: { en: 'Qty', zh: '数量' },
        viewCart: { en: 'View Cart', zh: '查看购物车' },
        continueShopping: { en: 'Continue Shopping', zh: '继续购物' },
    },

    // Connect 页面
    connect: {
        intro: {
            en: 'Our hope is that each piece becomes part of your daily ritual, and we welcome any conversation that helps it live well with you.',
            zh: '我们希望每一件作品都能融入您的日常生活，欢迎任何有助于它与您共处的交流。'
        },
        firstName: { en: 'First name', zh: '名' },
        lastName: { en: 'Last name', zh: '姓' },
        email: { en: 'Email address', zh: '邮箱地址' },
        message: { en: 'Your message', zh: '您的留言' },
        submit: { en: 'Submit', zh: '提交' },
        sending: { en: 'Sending...', zh: '发送中...' },
        success: { en: 'Message Sent!', zh: '消息已发送！' },
        successText: { en: "Thank you for reaching out. We'll get back to you soon.", zh: '感谢您的联系，我们会尽快回复。' },
        sendAnother: { en: 'Send Another Message', zh: '发送另一条消息' },
        error: { en: 'Something went wrong. Please try again or email us directly.', zh: '出错了。请重试或直接发送邮件给我们。' },
    },

    // Story 页面
    story: {
        title: { en: 'My Story', zh: '我的故事' },
        rootsTitle: { en: 'Roots in Tradition', zh: '传统根源' },
        rootsText: {
            en: 'I was born in an art-centered family in Fuzhou, where my grandfather, a heritage restorer of Chinese antiquities, first taught me to see beauty in the grain of wood and the patience of craft. Growing up surrounded by lacquerwork and traditional joinery, I learned that objects carry stories — of hands that shaped them, of time that aged them gracefully.',
            zh: '我出生在福州一个以艺术为中心的家庭，我的祖父是一位中国古董修复师，他最先教会我在木纹中看到美，在工艺中看到耐心。在漆器和传统木工技艺的熏陶下长大，我明白了物品承载着故事——关于塑造它们的双手，关于优雅老去的时光。'
        },
        educationTitle: { en: 'Education and Growth', zh: '教育与成长' },
        educationText: {
            en: "With a BFA from the China Academy of Art and an MFA from Parsons School of Design, I've had the privilege of studying under masters of both Eastern and Western traditions. My education taught me that true design lives at the intersection of material honesty and emotional resonance.",
            zh: '凭借中国美术学院的学士学位和帕森斯设计学院的硕士学位，我有幸师从东西方传统的大师。我的教育教会我，真正的设计存在于材料诚实与情感共鸣的交汇处。'
        },
        collectionTitle: { en: 'The Wooden Diary Collection', zh: '木质日记系列' },
        collectionText: {
            en: 'My breakout collection, The Wooden Diary, debuted at New York Fashion Week in 2022. It began as a meditation on memory — how we hold onto moments through objects, how the texture of cork beneath our fingers can transport us to a different time. Each piece in the collection is hand-turned in my Brooklyn studio, where I continue to explore the quiet dialogue between tradition and contemporary life.',
            zh: '我的突破性系列"木质日记"于2022年在纽约时装周首次亮相。它始于对记忆的冥想——我们如何通过物品留住时光，指尖下软木的纹理如何将我们带到另一个时代。系列中的每一件作品都在我布鲁克林的工作室手工车削，我在那里继续探索传统与当代生活之间的静谧对话。'
        },
        philosophyTitle: { en: 'Philosophy', zh: '理念' },
        philosophyQuote: {
            en: '"I believe in the emotional weight of handcraft and its potential to serve as public storytelling. Each object I create is meant to become part of your daily ritual — to hold your morning coffee, to rest on your desk, to travel with you through the years."',
            zh: '"我相信手工艺的情感分量及其作为公共叙事的潜力。我创作的每一件物品都旨在成为您日常仪式的一部分——盛放您的早晨咖啡，放置在您的桌上，陪伴您度过岁月。"'
        },
    },

    // Q&A 页面
    qa: {
        shippingTitle: { en: 'Shipping', zh: '配送' },
        shippingText1: {
            en: "We aim to dispatch items in stock within two days of receiving your order. If you need a speedy service please contact thewoodendiary@gmail.com and we'll do our best to get it to you sooner. Occasionally some items we have online are made to order. These orders will take 1-2 weeks, please note that although the wood shape and size will be the same, wood grain may differ. Please see items description for in stock and made to order items. Custom items may take 2-3 weeks.",
            zh: '我们的目标是在收到订单后两天内发货。如果您需要加急服务，请联系 thewoodendiary@gmail.com，我们会尽快为您处理。偶尔有些在线商品是定制的，这些订单需要1-2周，请注意虽然木材形状和尺寸相同，但木纹可能有所不同。请查看商品描述了解库存和定制商品。定制商品可能需要2-3周。'
        },
        shippingText2: {
            en: 'We ship internationally but please be aware that as we are based in NYC there may be import taxes. Responsibility of this payment is with the purchaser and we do not offer reimbursements or pay any import charges.',
            zh: '我们提供国际配送，但请注意，由于我们位于纽约，可能会产生进口税。此费用由买家承担，我们不提供退款或支付任何进口费用。'
        },
        shippingText3: {
            en: "Shipping costs vary according to country and package size. We would be happy to give you a shipping quote before purchase. We also have a free local pick up option. Just send us an email.",
            zh: '运费根据国家和包裹大小而异。我们很乐意在购买前为您提供运费报价。我们也提供免费本地自提服务，请发邮件给我们。'
        },
        careTitle: { en: 'Material Care', zh: '材料保养' },
        careText1: {
            en: 'Cork is a material of memory — resistant to insects, tolerant of water, and shaped by quiet time.',
            zh: '软木是一种有记忆的材料——防虫、耐水，在静谧的时光中成型。'
        },
        careText2: { en: 'If wet, let the piece air dry naturally.', zh: '如果弄湿，请让作品自然风干。' },
        careText3: { en: 'Avoid prolonged sunlight to preserve its tone and texture.', zh: '避免长时间暴晒以保持其色调和纹理。' },
        careText4: {
            en: "Each object is hand-turned in Ruiyu Zheng's studio from natural cork and finished with food-safe edible oil when intended for food contact.",
            zh: '每件作品都在郑锐宇的工作室用天然软木手工车削，如用于食品接触则用食品级食用油涂饰。'
        },
        careText5: {
            en: 'Every piece carries a mark on its base and comes with a care guide card, continuing the story between material, hand, and daily ritual.',
            zh: '每件作品底部都有标记，并附有保养指南卡，延续材料、双手与日常仪式之间的故事。'
        },
        refundTitle: { en: 'Refund & Exchanges', zh: '退换货' },
        refundText1: {
            en: "We really want you to be happy with your product and we're happy to discuss any issues you have.",
            zh: '我们真诚希望您对产品满意，我们很乐意讨论您遇到的任何问题。'
        },
        refundText2: {
            en: "Please get in touch via email to thewoodendiary@gmail.com to discuss an exchange or gift voucher. We only offer refunds in exceptional circumstances. Before returning please be sure to have the exchange approved.",
            zh: '请通过邮件 thewoodendiary@gmail.com 与我们联系，讨论换货或礼品券事宜。我们仅在特殊情况下提供退款。退货前请确保已获批准。'
        },
        refundText3: {
            en: 'If the item you received is defective or has been damaged during transit, please email thewoodendiary@gmail.com and we\'ll inform you of the necessary steps to take.',
            zh: '如果您收到的商品有缺陷或在运输过程中损坏，请发邮件至 thewoodendiary@gmail.com，我们会告知您需要采取的步骤。'
        },
        refundText4: {
            en: "Please note all items are made to order and may differ slightly in size, wood grain and shape compared to the website photo. We believe the joy of handmade is one of a kind!",
            zh: '请注意，所有商品均为定制，尺寸、木纹和形状可能与网站照片略有不同。我们相信手工制品的独特乐趣！'
        },
        photoCredit: {
            en: 'Web Photos are by Lingyi Li, Wenkai Cai, Xiaoqian Ling, Yuren Dong and Ruiyu Zheng',
            zh: '网站照片由李凌怡、蔡文凯、凌晓倩、董雨人和郑锐宇拍摄'
        },
    },

    // Draft 页面
    draft: {
        title: { en: 'Draft', zh: '手稿' },
        subtitle: { en: 'Design Process & Sketches', zh: '设计过程与草图' },
        description: {
            en: 'Every piece begins as a quiet thought — a sketch on paper, a memory of grain under fingertips, a question about how objects hold meaning in daily life.',
            zh: '每一件作品都始于一个安静的想法——纸上的一幅草图，指尖下木纹的记忆，关于物品如何在日常生活中承载意义的思考。'
        },
        comingSoon: { en: 'Coming soon...', zh: '即将推出...' },
        placeholderNote: {
            en: 'This section will feature design sketches, process photographs, and stories behind each collection.',
            zh: '本版块将展示设计草图、制作过程照片以及每个系列背后的故事。'
        },
        bodyText: {
            en: 'A new body of work exploring the dialogue between cork carving and silver, created in collaboration with silversmith Lingyi Li. Situated between traditional craftsmanship and contemporary expression, soft, porous surfaces meet cold, reflective metal, forming a tension between fragility and permanence. Through this material encounter, objects emerge as carriers of touch, memory, and transformation.',
            zh: '这是一个探索软木雕刻与银饰之间对话的全新系列，与银匠李凌逸合作创作。作品游走于传统手工艺与当代语言之间，让柔软多孔的软木表面与冰冷反光的金属相遇，在脆弱与永恒之间形成张力。通过这种材质的交汇，器物成为了触觉、记忆与蜕变的载体。'
        },
    },

    // Press 页面
    pressPage: {
        title: { en: 'Exhibitions & Press', zh: '展览&报道' },
        topic1: { en: 'Cork and Accessories Combination', zh: '软木与配饰结合' },
        topic2: { en: 'Schön! Magazine April Theme', zh: 'Schon杂志四月主题' },
        report1: { en: 'NYFW Report', zh: 'NYFW报道' },
        report2: { en: 'CCTV Report', zh: '央视报道' },
        report3: { en: 'Fuzhou Evening News Report', zh: '福州晚报报道' },
        report4: { en: 'Vogue Report', zh: 'Vogue报道' },
        report5: { en: 'ELLE Report', zh: 'ELLE报道' },
    },

    // Showcase 页面
    showcase: {
        title: { en: 'Showcase', zh: '展示' },
        weddingTab: { en: 'Wedding Collections', zh: '婚礼系列' },
        runwayTab: { en: 'Runway Designs', zh: '时装秀设计' },
        weddingTitle: { en: 'Cultural Heritage Bridal', zh: '文化传承婚礼系列' },
        weddingDesc: {
            en: 'Bridal collection merging traditional Chinese elements with modern silhouettes. Each piece tells a story of heritage meeting contemporary craft.',
            zh: '将中国传统元素与现代轮廓融合的婚礼系列。每一件作品都讲述着传统与当代工艺相遇的故事。'
        },
        runwayTitle: { en: 'Urban Diary Collection', zh: '都市日记系列' },
        runwayDesc: {
            en: 'Fashion Week 2022 collection inspired by New York cityscapes and the quiet rituals of daily life.',
            zh: '2022时装周系列，灵感来自纽约城市景观和日常生活的静谧仪式。'
        },
    },

    // Stockists 页面
    stockists: {
        p1: {
            en: 'My sincere gratitude to the cork carving artisans for their support and dedication.\nThrough their patience and mastery, this delicate craft continues to endure and breathe with new life today.',
            zh: '衷心感谢软木画手工艺人的支持与陪伴。\n正是因为有他们的坚持与传承，\n这门精湛而细腻的技艺得以延续，\n并在当代焕发新的生命力。'
        },
        p2: {
            en: 'Through exploration and innovation, I hope cork carving—an intangible cultural heritage—can continue to evolve while honoring its roots, allowing more people to see, understand, and cherish its beauty.',
            zh: '我始终希望，通过不断的探索与创新，\n让软木画这一非物质文化遗产在尊重传统的基础上继续发展，\n被更多人看到、理解和珍视，\n让这份珍贵的文化记忆长久地流传下去。'
        },
        p3: {
            en: 'For me, the journey of beauty is not only a remembrance of the past, but a path that points toward the future. ✨',
            zh: '我期待--美的历程，是指向未来的 ✨'
        }
    },

    // 首页日记本
    diary: {
        page1Date: { en: '9/01', zh: '9/01' },
        page1Left: {
            en: 'Today, sunlight through the window traced the texture of passion fruit with exceptional clarity. The beauty of life often hides in these small, concrete details.',
            zh: '今日，阳光透过窗棂，将百香果的纹理勾勒得格外清晰，生命中的美好常常藏在这些微小而具体的细节里。'
        },
        page1Right: {
            en: 'This old wooden chair holds countless stories and moments of quiet time. It reminds me that simplicity is eternal elegance.',
            zh: '这把老旧的木椅，承载了多少故事与静默时光。它提醒我，简单即是永恒的优雅。'
        },
        page2Date: { en: '9/02', zh: '9/02' },
        page2Left: {
            en: 'At dawn, when the city bustle has yet to fully awaken, a cup of coffee and a diary open a new chapter.',
            zh: '清晨，城市的喧嚣还未完全苏醒，一杯咖啡，一份日记，开启了新的篇章。'
        },
        page2Right: {
            en: 'Every time I turn these pages, it becomes a dialogue with the past. Grateful for those moments that shaped who I am today.',
            zh: '每一次翻阅，都是与过往的对话。感谢那些光阴，塑成了现在的我。'
        },
        page3Date: { en: '9/03', zh: '9/03' },
        page3Left: {
            en: 'Sparks of inspiration often flash in unexpected moments, like a newly opened canvas waiting for colors to fill it.',
            zh: '灵感的火花常常在不经意间闪现，如同这页新开的画布，等待着色彩的注入。'
        },
        page3Right: {
            en: 'Life is a diary that can never be finished. Each day is a brand new page.',
            zh: '生活，是一本永远写不完的日记，每一天都是全新的书页。'
        },
    },

    // 产品数据翻译
    products: {
        // 产品名称
        product1Name: { en: 'Hand Craft Egg Cup', zh: '手工蛋杯' },
        product1Desc: { en: 'Hand-turned cork egg cup, food-safe finished. Each piece carries unique grain patterns.', zh: '手工车削软木蛋杯，食品安全涂层。每件作品都有独特的纹理。' },
        product1Sub: { en: 'Cork Tableware', zh: '软木餐具' },

        product2Name: { en: 'Cake Stand Up', zh: '蛋糕托盘' },
        product2Desc: { en: 'Elegant cork cake stand for your special occasions. Perfect centerpiece for celebrations.', zh: '优雅的软木蛋糕托盘，适合您的特殊场合。完美的庆祝焦点装饰。' },
        product2Sub: { en: 'Cork Tableware', zh: '软木餐具' },

        product3Name: { en: 'Cork Silver Necklace', zh: '软木银项链' },
        product3Desc: { en: 'Delicate cork pendant with sterling silver chain. Lightweight and unique.', zh: '精致的软木吊坠配纯银链条。轻盈且独特。' },
        product3Sub: { en: 'Jewelry', zh: '珠宝首饰' },

        product4Name: { en: 'Cork Leather Necklace', zh: '软木皮革项链' },
        product4Desc: { en: 'Cork pendant on genuine leather cord. Natural and earthy aesthetic.', zh: '软木吊坠配真皮绳。自然质朴的美感。' },
        product4Sub: { en: 'Jewelry', zh: '珠宝首饰' },

        product5Name: { en: 'Little Plant Pot 1', zh: '迷你花盆 1' },
        product5Desc: { en: 'Small hand-turned cork pot for succulents. Breathable and moisture-regulating.', zh: '小型手工车削软木花盆，适合多肉植物。透气调湿。' },
        product5Sub: { en: 'Home Decor', zh: '家居装饰' },

        product6Name: { en: 'Little Plant Pot 2', zh: '迷你花盆 2' },
        product6Desc: { en: 'Compact cork pot for small plants. Modern minimalist design.', zh: '紧凑型软木花盆，适合小型植物。现代极简设计。' },
        product6Sub: { en: 'Home Decor', zh: '家居装饰' },

        product7Name: { en: 'Cork Lapel Pin', zh: '软木胸针' },
        product7Desc: { en: 'Unique cork lapel pin for your wardrobe. Statement piece with natural texture.', zh: '独特的软木胸针，点缀您的衣橱。天然纹理的点睛之笔。' },
        product7Sub: { en: 'Accessories', zh: '配饰' },

        product8Name: { en: 'NY Signature', zh: '纽约签名系列' },
        product8Desc: { en: 'New York inspired cork signature piece. Urban meets natural.', zh: '灵感源自纽约的软木签名作品。都市与自然的相遇。' },
        product8Sub: { en: 'Accessories', zh: '配饰' },
    },

    // Language toggle
    language: {
        switch: { en: '中文', zh: 'EN' },
    },
};

export default translations;
